/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pushToSetting } from "../../redux/slices/SettingSclice";
import { setSetting } from "../../Components/action/common";
import { AIChatGredientIcon } from "../../Components/LandingHeader/Feedback/icons/Icons";

function AiAssistant({ activeTab, setActiveTab }) {
    const { theme, colorPicker, colorPickerDark } = useSelector(state => state.theme);
    const [localSettings, setLocalSettings] = useState({});
    const [saving, setSaving] = useState(false);
    const {settings} = useSelector(state => state.settings);
    const dispatch = useDispatch();
    const aboutYouRef = useRef(null);
    const maxCharLimit = 2000;

    const saveSettings = async (e) => {
        e.preventDefault();
        setSaving(true)
        try{
            const newSettings = { ...settings, ...localSettings };
            dispatch(pushToSetting(newSettings));
            await setSetting({ "settings": newSettings })
            setSaving(null)
        } catch(e) {
            console.log(e)
            setSaving(false)
        }
    }

    const handleChange = (value, name) => {
        setLocalSettings((prev) => ({ ...prev, [name]: value }));
        setSaving(false)
    }

    return (
        <>
            <li
            css={{
                '&:hover .accordion-title': {
                color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c")) ? "white !important" : (theme == "dark" && colorPickerDark == "#f8961e") ? "black !important" : (theme == "dark" && colorPickerDark == "#ffca3a") ? "black !important" : (theme == "dark" && colorPickerDark == "#27cb9a") ? "black !important" : (theme == "dark" && colorPickerDark == "#4cc9f0") ? "black !important" : "white !important") : "white !important"
                },
                '.accordion-title': {
                color: theme == "dark" ? (((theme == "dark" && colorPickerDark == "#ef233c") && (activeTab == "aiassistant")) ? "white !important" : ((theme == "dark" && colorPickerDark == "#f8961e") && (activeTab == "aiassistant")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#ffca3a") && (activeTab == "aiassistant")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#27cb9a") && (activeTab == "general")) ? "black !important" : ((theme == "dark" && colorPickerDark == "#4cc9f0") && (activeTab == "aiassistant")) ? "black !important" : "white !important") : "white"
                }
            }}
            className={`li-setting-tab ${activeTab == "aiassistant" ? 'active' : ''}`}>
                <div className="settings-accordion-tab"
                    onClick={() => { setActiveTab(activeTab => activeTab == 'aiassistant' ? null : 'aiassistant'); }}
                    style={{ background: theme == "dark" ? "black" : "" }}
                    css={{
                    background: activeTab == 'aiassistant' ? (theme == 'dark' ? `linear-gradient(0deg,var(--accent-color-10),var(--accent-color-10)),#000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important`) : '',
                    '&:hover': {
                        background: theme == 'dark' ? `linear-gradient(0deg, var(--accent-color-10), var(--accent-color-10)), #000 !important` : `linear-gradient(0deg, var(--accent-color), var(--accent-color)), #ffffff !important`,
                    }
                    }}>
                    <div className="settings-accordion-heading">
                    <figure className="settings-icon">
                        <AIChatGredientIcon width="18" height="18" color="rgba(0, 0, 0, 0.3)" customClass="img-default dark:invert-color" />
                    </figure>
                    <h3 className="accordion-title uppercase dark:text-white">AI Assistant</h3>
                    </div>
                    <div className="settings-accordion-arrow">
                        <img src="/images/arrow-down.svg" className="dark:invert-color" />
                    </div>
                </div>
                {
                    activeTab == 'aiassistant' 
                    && 
                    <div className="settings-accordion-content">
                        <div className="inner-form relative">
                            <label className="field-label font text-black mb-0">About You</label>
                            <div className="block-field-info font text-secondary text-base mb-0">Help your AI Assistant give you more tailored, relevant responses by sharing any key information you'd like it to know about you.</div>
                            <div className="block-field-info font text-secondary text-base"><a className="link-text text-black dark:text-white underline mt-[5px]" href="https://lifetab.co/blog/personalising-your-ai-assistant-what-to-include-in-your-background-information" target="_blank">Learn more about the kind of information you might want to share with your assistant here</a></div>
                            <div className="field-block mt-[30px]">    
                                <div className="field-data">
                                    <div style={{position: 'relative', width: '100%'}}>
                                      <textarea 
                                        css={{
                                          maxWidth: '100% !important', 
                                          height: 'auto !important',
                                          marginBottom: '20px'
                                        }} 
                                        ref={aboutYouRef}
                                        rows="8" 
                                        maxLength={maxCharLimit}
                                        defaultValue={settings?.aiAssistantAboutYou ?? ''} 
                                        className="input-field" 
                                        onInput={(e) => {
                                          if (e.target.value.length <= maxCharLimit) {
                                            handleChange(e.target.value, "aiAssistantAboutYou")
                                          }
                                        }} 
                                      />
                                      {/* <TextAreaWithSpeech color={colorPicker} rows="5" defaultValue={settings?.aiAssistantAboutYou ?? ''} customClass="input-field" onInput={(value) => handleChange(value, "aiAssistantAboutYou")} /> */}
                                      <div 
                                        style={{
                                          position: 'absolute',
                                          bottom: '0',
                                          right: '0',
                                          fontSize: '14px',
                                          color: '#666'
                                        }}
                                      >
                                        {(aboutYouRef.current?.value?.length || 0)}/{maxCharLimit}
                                      </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-0">
                                {/* <label className="field-label font text-black mb-0">API Keys</label>
                                <div className="block-field-info font text-secondary text-base">API key used for AI Assistant.</div>
                                <div className="field-block mt-[30px]">
                                    <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>OpenAI</label>    
                                    <div className="field-data">
                                        <input defaultValue={settings?.openAiApiKey ?? ''} type="text" className="input-field" placeholder="Enter your OpenAI API key" onInput={(e) => handleChange(e.target.value, "openAiApiKey")} />
                                    </div>
                                </div>
                                <div className="field-block mt-[30px]">
                                    <label className="field-label" style={{ color: theme == "dark" ? "white" : "", opacity: theme == "dark" ? 0.7 : '' }}>Anthropic</label>
                                    <div className="field-data">
                                        <input defaultValue={settings?.anthropicApiKey ?? ''} type="text" className="input-field" placeholder="Enter your Anthropic API key" onInput={(e) => handleChange(e.target.value, "anthropicApiKey")} />
                                    </div>
                                </div> */}

                                <div className="field-block">
                                    <button className="changeName mt-5"
                                    css={{
                                        background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.9), rgba(var(--theme-mode-rgb-white), 0.9)), linear-gradient(0deg, var(--accent-color), var(--accent-color)), linear-gradient(0deg, rgba(var(--theme-mode-rgb-white-reverse), 0.05), rgba(var(--theme-mode-rgb-white-reverse), 0.05)), var(--theme-mode-color-white) !important`,
                                        color: `var(--accent-color) !important`
                                                
                                    }}
                                    onClick={saveSettings}>{saving === true ? 'Saving...' : (saving === false ? 'Save Settings' : 'Saved')}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </li>
        </>
    );
}

export default AiAssistant;